<template>
    <section class="content">
        <div class="row">
            <div class="col-md-12">
                <collections-form :collection="collection" :disabled="disabled" @activate-mod="activateMod()"
                                  @click="updateCollection(collection)" @change-collection-prop="changeCollectionProps"
                                  :showLabels="true"></collections-form>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <div class="box box-primary">
                    <div class="box-header with-border">
                        <h3 class="box-title">Sequenze</h3>
                    </div>
                    <div class="box-body">
                        <div class="row"  v-if="$accessControl.isOperator($store.state.profile.profile)">
                            <div class="col-md-3 col-md-offset-3 text-right">
                                <multiselect
                                        v-model="searchFund"
                                        :options="funds"
                                        track-by="id"
                                        label="denominazione"
                                        placeholder="seleziona"
                                        SelectLabel="seleziona"
                                        SelectedLabel="selezionato"
                                        DeselectLabel="deseleziona"
                                        id="funds"
                                        name="funds"
                                        :clear-on-select="false"
                                        :searchable="true"
                                        @search-change="fundsFind"
                                        @select="searchFundSelected">
                                </multiselect>
                            </div>
                            <div class="col-md-3 text-right">
                                <multiselect
                                        v-model="searchReel"
                                        :options="reels"
                                        track-by="id"
                                        label="identificativo"
                                        placeholder="seleziona"
                                        SelectLabel="seleziona"
                                        SelectedLabel="selezionato"
                                        DeselectLabel="deseleziona"
                                        id="reels"
                                        name="reels"
                                        :clear-on-select="false"
                                        :searchable="true"
                                        :disabled="reels.length < 1">
                                </multiselect>
                            </div>
                            <div class="col-md-3 text-right">
                                <button class="btn btn-success btn-block"
                                        v-on:click.prevent="storeSequence"
                                        :disabled="searchFund === null || searchReel === null">
                                    <i class="fa fa-circle-o-notch fa-spin" v-if="storeSequenceLoader"></i>
                                    Inserisci nuova sequenza
                                </button>
                            </div>
                        </div>
                        <br/>
                        <v-server-table url="" :columns="columns" :options="options" name="sequences" ref="sequences"
                                        @row-click="showSequence">
                            <template slot="reel_identificativo" slot-scope="props">
                                <div class="form-group">
                                    <router-link :to="{ name: 'reelsShow', params: { id: props.row.reel_id }}" tag="h4">
                                      <span class="label label-default">
                                          <strong>{{ props.row.reel_identificativo }}</strong>
                                      </span>
                                    </router-link>
                                </div>
                            </template>
                            <template slot="actions" slot-scope="props">
                                <div>
                                    <button class="btn btn-warning btn-sm"
                                            v-on:click.stop="detachSequence(props.row.id)"
                                            v-if="$accessControl.isOperator($store.state.profile.profile)">
                                        <i class="fa fa-trash"></i>
                                    </button>
                                </div>
                            </template>
                        </v-server-table>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
  import types from '../../store/mutation-types'
  import collectionsApi from '../../api/collections'
  import collectionsForm from './CollectionsForm.vue'
  import Collection from '@/models/collection'
  import Multiselect from 'vue-multiselect'
  import 'vue-multiselect/dist/vue-multiselect.min.css'
  import funds from '@/api/funds'
  import sequences from '@/api/sequences'
  import Sequence from '@/models/sequence'

  export default {
    components: {
      collectionsForm, Multiselect
    },

    data () {
      return {
        collection: false,
        disabled: true,
        columns: [
          'reel_identificativo', 'titolo', 'actions'
        ],
        options: {
          saveState: false,
          headings: {
            'reel_identificativo': 'Identificativo bobina'
          },
          sortable: [
            'progressivo'
          ],
          requestFunction: function (query) {
            return collectionsApi.sequences(this.$route.params.id, query)
          }
        },
        searchFund: null,
        searchReel: null,
        funds: [],
        reels: [],
        storeSequenceLoader: false
      }
    },

    beforeCreate () {
      collectionsApi.show(this.$route.params.id)
        .then((response) => {
          this.collection = response
        })
    },

    created () {
      this.$store.commit(types.SET_HEADER_STATE, {
        pageTitle: 'Raccolte inserite',
        createButton: {
          display: true,
          text: 'Nuova raccolta',
          to: '/collection'
        }
      })
    },

    methods: {
      activateMod () {
        this.disabled = !this.disabled
      },
      updateCollection (collection) {
        this.loader = true
        collectionsApi.update(this.$route.params.id, collection)
          .then((response) => {
            toastr.success('La raccolta è stata salvata correttamente')
            this.loader = false
            this.disabled = true
          })
          .catch((response) => {
            this.loader = false
          })
      },
      changeCollectionProps (collection) {
        this.collection = new Collection(false, collection)
      },
      showSequence (row) {
        this.$router.push({name: 'sequencesShow', params: {id: row.row.id, showMap: true}})
      },
      detachSequence (sequence) {
        if (confirm('Sei sicuro di procedere?')) {
          this.loading = true
          collectionsApi.detachSequence(this.$route.params.id, sequence)
            .then((response) => {
              this.$refs.sequences.refresh()
              toastr.success('La sequenza è stata correttamente rimossa da questa raccolta')
              this.loading = false
            })
            .catch((response) => {
              this.loading = false
            })
        }
      },
      fundsFind (query) {
        funds.select(query)
          .then((response) => {
            this.funds = response.data.data
          })
      },
      searchFundSelected (fund) {
        funds.reels(fund.id, {
          limit: 10000,
          ascending: 1,
          page: 1,
          byColumn: 0,
          orderBy: 'identificativo'
        })
          .then((resp) => {
            this.reels = resp.data.data
          })
      },
      storeSequence () {
        this.storeSequenceLoader = true
        sequences.store(new Sequence(false, {reel_id: this.searchReel.id, collections: {data: [this.collection]}}))
          .then((response) => {
            toastr.success('La sequenza è stata inserita correttamente')
            this.$refs.sequences.refresh()
          })
          .finally((response) => {
            this.storeSequenceLoader = false
          })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/collections/CollectionsShow.vue